require('./bootstrap');

import {createApp, h} from 'vue';
import {mapGetters} from "vuex";
import {App as InertiaApp, plugin as InertiaPlugin} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import store from './Stores'

import {toFaNum} from "./helpers";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Iranget';

const el = document.getElementById('app');
const rootEl = document.getElementById('root');

const app = createApp();
app.mixin({
    methods: {
        toFaNum,
    },
    computed: {
        ...mapGetters('cart', ['stateCount'])
    },
})

import {VueReCaptcha} from 'vue-recaptcha-v3'

import RecaptchaField from "./Components/RecaptchaField";

if (el || document.getElementsByClassName('contact-form').length) {
    app.use(VueReCaptcha, {siteKey: window.recaptcha_site_key})
    app.component('recaptcha-field', RecaptchaField);
}
if (el) {
    app.component('inertia-app', {
        render: () =>
            h(InertiaApp, {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            }),
    })
}


import AddToCartSingle from "./Components/AddToCartSingle";

app.component('add-to-cart-single', AddToCartSingle);

import Cart from "./Components/Cart";

app.component('cart', Cart);

import Toasts from "./Components/Toasts";

app.component('toasts', Toasts);

import LikeBtn from "./Components/LikeBtn";

app.component('like-btn', LikeBtn);

app.use(InertiaPlugin);
app.use(store);

app.config.globalProperties.$filters = {
    strippedContent: (value) => value.replace(/<\/?[^>]+>/ig, " ")
}

store.dispatch('cart/getCartItems');
app.mount(rootEl)

InertiaProgress.init({color: '#4B5563'});

import Splide from '@splidejs/splide';

let toggleNavbarPosition = function () {
    const navbar = document.getElementById('topNavbar')
    const topMsg = document.getElementById('topMsg')
    const offset = topMsg ? topMsg.clientHeight : 0
    if (window.scrollY >= offset) {
        navbar.classList.add('fixed-top')
        document.getElementsByTagName("BODY")[0].style.paddingTop = `${navbar.clientHeight}px`
    } else {
        navbar.classList.remove('fixed-top')
        document.getElementsByTagName("BODY")[0].style.paddingTop = 0
    }
}
toggleNavbarPosition()

let toggleSingleProductNavPosition = function () {
    const nav = document.getElementById('singleProductNav')
    if (!nav) {
        return
    }
    const navbar = document.getElementById('topNavbar')
    const productBody = document.getElementById('productBody')
    const offset = -navbar.clientHeight + nav.parentElement.offsetTop

    if (window.scrollY >= offset) {
        nav.classList.add('fixed-top')
        nav.parentElement.style.height = `${nav.clientHeight}px`
        if (window.scrollY <= productBody.offsetTop + productBody.clientHeight - navbar.clientHeight - nav.clientHeight) {
            nav.style.top = `${navbar.clientHeight}px`
        } else {
            nav.style.top = `-500px`
        }
    } else {
        nav.classList.remove('fixed-top')
        nav.parentElement.style.height = 'auto'
        nav.style.top = 0
    }

    Array.prototype.slice.call(nav.getElementsByTagName('A')).forEach(el => {
        el.className = 'nav-link py-2 px-3 text-gradient-primary opacity-50 fw-bold'
    })
    if (document.getElementById('reviewsSection') && document.getElementById('reviewsSection').offsetTop <= window.scrollY + navbar.clientHeight + nav.clientHeight) {
        document.querySelector('#singleProductNav a[href="#reviewsSection"]').className = 'nav-link py-2 px-3 active text-gradient-primary shadow rounded-pill fw-bolder'
    } else if (document.getElementById('relatedSection') && document.getElementById('relatedSection').offsetTop <= window.scrollY + navbar.clientHeight + nav.clientHeight) {
        document.querySelector('#singleProductNav a[href="#relatedSection"]').className = 'nav-link py-2 px-3 active text-gradient-primary shadow rounded-pill fw-bolder'
    } else if (document.getElementById('faqsSection') && document.getElementById('faqsSection').offsetTop <= window.scrollY + navbar.clientHeight + nav.clientHeight) {
        document.querySelector('#singleProductNav a[href="#faqsSection"]').className = 'nav-link py-2 px-3 active text-gradient-primary shadow rounded-pill fw-bolder'
    } else if (document.getElementById('descriptionSection') && document.getElementById('descriptionSection').offsetTop <= window.scrollY + navbar.clientHeight + nav.clientHeight) {
        document.querySelector('#singleProductNav a[href="#descriptionSection"]').className = 'nav-link py-2 px-3 active text-gradient-primary shadow rounded-pill fw-bolder'
    }
}
toggleSingleProductNavPosition()

window.onscroll = function () {
    toggleNavbarPosition()
    toggleSingleProductNavPosition()
}
window.onresize = function () {
    toggleNavbarPosition()
    toggleSingleProductNavPosition()
}


if (document.getElementsByClassName('hero-splide').length) {
    const heroSplide = new Splide('.hero-splide', {
        type: 'loop',
        direction: 'rtl',
        perPage: 1.5,
        focus: 'center',
        cover: true,
        heightRatio: .3,
        gap: 24,
        autoplay: true,
        breakpoints: {
            575: {
                perPage: 1,
                gap: 10,
                heightRatio: .6,
            }
        }
    });
    heroSplide.on('resized', function () {
        document.getElementsByClassName('hero-splide')[0].getElementsByClassName('splide__track')[0].classList.remove('d-none')
        document.getElementsByClassName('hero-splide')[0].getElementsByClassName('holder')[0].classList.add('d-none')
    })
    heroSplide.mount()
}

if (document.getElementsByClassName('reviews-splide').length) {
    new Splide('.reviews-splide', {
        type: 'loop',
        direction: 'rtl',
        fixedWidth: 312,
        focus: 'center',
        gap: 16,
        arrows: false,
        autoplay: true,
    }).mount();
}

if (document.getElementsByClassName('brands-splide').length) {

    new Splide('.brands-splide', {
        type: 'loop',
        direction: 'rtl',
        fixedWidth: 65,
        focus: 'center',
        gap: 96,
        arrows: false,
        autoplay: true,
        pagination: false,
    }).mount();
}


